import { makeReducer } from '../../core/make-reducer';
import { makeActionCreators } from '../../core/make-action-creators';
import * as API from '../../core/api';
import Memo from '../../memos/class';

export const actions = {
  REQUEST: 'Dora/user-goals-memos/REQUEST',
  RECEIVE: 'Dora/user-goals-memos/SUCCESS',
  FAIL: 'Dora/user-goals-memos/FAIL',
  UPDATE_THANKS_RECEIVED_FROM:
    'Dora/user-goals-memos/UPDATE_THANKS_RECEIVED_FROM',
};

export default makeReducer({
  actions,
  handlers: {
    [actions.UPDATE_THANKS_RECEIVED_FROM]: (state, action) => ({
      ...state,
      data: state.data.map((memo) => {
        if (memo._id === action.memoId) {
          return { ...memo, thanksReceivedFrom: action.thanksReceivedFrom };
        }

        return memo;
      }),
    }),
  },
});

const actionCreators = makeActionCreators({
  reducerName: 'userGoalsMemos',
  actions,
  requestDataCall: (store, params) =>
    API.get(`memos?user=${params.user}`).then((memos) =>
      memos.filter((m) => !!m.goal).map((memo) => new Memo(memo))
    ),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;
export const updateThanksReceivedFrom = (memoId, thanksReceivedFrom) => ({
  type: actions.UPDATE_THANKS_RECEIVED_FROM,
  memoId,
  thanksReceivedFrom,
});



// WEBPACK FOOTER //
// ./src/goals/memos/duck.js